'use client';
import { ButtonProps, SxProps } from '@mui/material';
import { FilledButtonWrapper, FilledButtonLabel } from './styles';

interface FilledButtonProps extends ButtonProps {
    readonly label: string;
    readonly icon?: React.ReactNode;
    readonly isBig?: boolean;
    readonly themeColor?: string;
    readonly labelStyle?: SxProps;
    readonly fullWidth?: boolean;
}

const FilledButton = (props: FilledButtonProps) => {
    const { icon, label, isBig, labelStyle, fullWidth, ...buttonProps } = props;
    return (
        <FilledButtonWrapper
            isBig={isBig}
            fullWidth={fullWidth}
            variant={'contained'}
            themeColor={props.themeColor}
            {...buttonProps}
        >
            {icon && icon}
            <FilledButtonLabel hasIcon={!!icon} isDisabled={props.disabled} sx={labelStyle}>
                {label}
            </FilledButtonLabel>
        </FilledButtonWrapper>
    );
};

export { FilledButton };
